import React, { useState } from 'react'
import axios from 'axios'
// import {useSelector} from "react-redux"
// import { useNavigate } from "react-router-dom"

import { connect } from 'react-redux'
import {contentAfterLogin} from "../../redux/action-creator"
import {store} from "../../redux/store"
// import "./Signin.css"
const Forgotpass = (props) => {
    // const navigate=useNavigate()

    const [changePassword, setChangePassword] = useState({
        
        email: "",
        pass: "",
        cpass:""
    })
    // const myState=useSelector(state=>state.ourState.showNav)
    console.log("mystate",store.getState())
    // const [signToggle, setSignToggle]=useState(false)

    // value={postData.title} 
    //       onChange={(e)=>setPostData({
    //           ...postData,title:e.target.value
    //       })}
const changePasswordHandle=(e)=>{
    // e.preventDefault()
    e.preventDefault()
         axios.patch("http://localhost:9090/changepassword",changePassword).then(res=>{
            console.log("+++++ res +++++",res)
            if(res.data.message === "password changed"){
                // console.log("+++++ console.log ++++")
                // store.getState().ourState.showNav=true
                props.testFun()
            }
        }).catch(err=>{
            console.log("++++ err +++++",err)
        })
}
 
    
   
    // const [signToggle, setSignToggle] = useState(false)


    // const signupHandle = async(e) => {
    //     e.preventDefault()
    //     await axios.post("http://localhost:9090/signup",signupDetails).then(res=>{
    //         console.log("+++++ res +++++",res)
    //     }).catch(err=>{
    //         console.log("++++ err +++++",err)
    //     })


       

    //     // setSignToggle(false)
    // }
    // const loginHandle = (e) => {
        // e.preventDefault()
        //  axios.post("http://localhost:9090/signin",signinDetails).then(res=>{
        //     console.log("+++++ res +++++",res)
        //     if(res.data.message=="Login Success"){
        //         console.log("+++++ console.log ++++")
        //         // store.getState().ourState.showNav=true
        //         props.testFun()
        //     }
        // }).catch(err=>{
        //     console.log("++++ err +++++",err)
        // })
        // // setSignToggle(true)
    // }

    return (
        <div>
            <div className="signcontainer">
                
                    
                   

              
                     
                     <div className="signinform-container">
                        <form className='signUpform' action="#">
                            <h1 className='titleHeading'>Change Password</h1>
                            <div className="social-container">
                                <a href="https://www.google.com" className="social"><i className="fab fa-facebook-f"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-google-plus-g"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                            <input type="email"

                                value={changePassword.email}
                                onChange={(e) => setChangePassword({
                                    ...changePassword, email: e.target.value
                                })}

                                required={true} placeholder="Email" />
                             <input 
                             value={changePassword.pass}
                             onChange={(e)=>setChangePassword({
                                         ...changePassword,pass:e.target.value
                                    })}type="password" required={true} placeholder="Password" />
                                     <input 
                             value={changePassword.cpass}
                             onChange={(e)=>setChangePassword({
                                         ...changePassword,cpass:e.target.value
                                    })}type="password" required={true} placeholder="Password" />
                           
                            <button type='submit' onClick={changePasswordHandle}>Change Password</button>
                        </form>
                       
                       

                        

                    </div>
                



            </div>

        </div>
    )
}
const mapStateToProps=(state)=>{
    return{
        adCa:state.ourState.showNav

    }
}
const mapDispatchToProps=(dispatch)=>{
    return{
    testFun:()=>dispatch(contentAfterLogin())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Forgotpass)
// export default Signin